import React from "react"
import { graphql } from "gatsby"
import { FieldGroup } from "./formBuilder-types"
import { FieldsParser } from "./FieldsParser"
import { Content } from "components/content/Content"

export const FormFieldGroup = ({
  section_details,
  form_fields,
  className,
}: FieldGroup) => {
  const getInputFieldsCount = () => {
    let count = 0
    form_fields.map(({ form_field_type }) => {
      const fieldType = form_field_type

      if (
        fieldType === "Text" ||
        fieldType === "Radio" ||
        fieldType === "Date" ||
        fieldType === "Dropdown Select"
      ) {
        count++
      }
    })
    return count
  }
  const inputFieldsCount = getInputFieldsCount()

  return (
    <div className={`field-group`}>
      {section_details.data &&
        section_details.data.section_details.length > 0 && (
          <Content content={section_details.data.section_details} />
        )}
      <div
        className={`field-group__fields ${className}`}
        style={
          className === "landing_page"
            ? { gridTemplateColumns: `1fr 1fr` }
            : inputFieldsCount <= 3
            ? {
                gridTemplateColumns: `repeat(${inputFieldsCount}, 1fr)`,
              }
            : { gridTemplateColumns: `repeat(3,1fr)` }
        }
      >
        {form_fields.map(({ id, ...fieldProps }, index) => {
          return <FieldsParser key={`${id}-${index}`} {...fieldProps} />
        })}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment StrapiFormFieldGroupFragment on STRAPI_FORM_FIELD_GROUP {
    id
    section_details {
      data {
        section_details
      }
    }
    form_fields {
      id
      form_field
      form_field_type
      hidden_field_value
      label
      options
      required
      custom_place_holder
    }
  }
`
